import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { addUserToFundByLink } from 'services/fund'
import posthog from 'posthog-js'

export default function useSetAddUserByLink() {
    const navigate = useNavigate()
    const { mutate } = useMutation({
        mutationFn: (payload: IAddNewUserToFundPayload) => {
            return addUserToFundByLink(payload)
        },
        onSuccess: (data) => {
            posthog.capture('fund_joined')
            toast.success('با موفقیت به صندوق اضافه شدید.')
            navigate(-1)
        },
        onError: (error: any) => {
            // Same 406 details as the manager add-member endpoint, but here the
            // rejoiner is the removed member themself — they cannot re-activate
            // their own poolship, only a manager can.
            const detail = error?.response?.data?.detail
            posthog.capture('fund_join_failed', {
                error_detail: typeof detail === 'string' ? detail : undefined,
                status: error?.response?.status,
            })
            if (detail === 'Activate existed member.') {
                toast.error(
                    'شما قبلاً عضو این صندوق بوده‌اید. از مدیر صندوق بخواهید عضویت شما را دوباره فعال کند.',
                    { autoClose: 8000 }
                )
            } else if (detail === 'Poolship already exists.') {
                toast.error('شما هم‌اکنون عضو این صندوق هستید.')
            } else {
                toast.error('مشکلی پیش آمده!')
            }
        },
    })
    return { mutate }
}
